import {ListItem} from '@github-ui/list-view/ListItem'
import {ListItemDescription} from '@github-ui/list-view/ListItemDescription'
import {ListItemMainContent} from '@github-ui/list-view/ListItemMainContent'
import {ListItemTitle} from '@github-ui/list-view/ListItemTitle'
import {Label, RelativeTime} from '@primer/react'
import {type ComponentProps, memo} from 'react'

import styles from './RepositoryProjects.module.css'

export interface ProjectListItem {
  id: number | string
  number: number
  title: string
  shortDescription: string | null
  url: string
  updatedAt: string | null
  public: boolean
}

interface ProjectListRowProps {
  project: ProjectListItem
  secondaryActions?: ComponentProps<typeof ListItem>['secondaryActions']
}

function ProjectListRowComponent({project, secondaryActions}: ProjectListRowProps) {
  const title = (
    <ListItemTitle value={project.title} href={project.url}>
      {!project.public && (
        <Label size="small" variant="secondary" className={styles.privateLabel}>
          Private
        </Label>
      )}
    </ListItemTitle>
  )

  return (
    <ListItem title={title} className={styles.projectRow} secondaryActions={secondaryActions}>
      <ListItemMainContent>
        <ListItemDescription className={styles.listItemContent}>
          {project.shortDescription && <p className={styles.projectDescription}>{project.shortDescription}</p>}
          <div className={styles.projectMeta}>
            <span>
              #{project.number}
              {project.updatedAt && (
                <>
                  {' '}
                  updated <RelativeTime date={new Date(project.updatedAt)} />
                </>
              )}
            </span>
          </div>
        </ListItemDescription>
      </ListItemMainContent>
    </ListItem>
  )
}

export const ProjectListRow = memo(ProjectListRowComponent)
